/**
 * Icon set — copied verbatim from the approved kit design (`app.js` paths),
 * exposed as a typed map so the player shell keeps design parity.
 */
export const paths: Record<string, string> = {
  'arrow-up-right': '<path d="M7 17 17 7M7 7h10v10"/>',
  'arrow-right': '<path d="M4 12h16m-6-6 6 6-6 6"/>',
  'chevron-down': '<path d="m6 9 6 6 6-6"/>',
  'chevron-right': '<path d="m9 6 6 6-6 6"/>',
  x: '<path d="m6 6 12 12M18 6 6 18"/>',
  film: '<rect x="3" y="4" width="18" height="16" rx="2"/><path d="M7 4v16M17 4v16M3 9h4m-4 6h4m10-6h4m-4 6h4"/>',
  tv: '<rect x="3" y="7" width="18" height="14" rx="2"/><path d="m8 3 4 4 4-4"/>',
  sparkles:
    '<path d="m12 3 2.3 6.7L21 12l-6.7 2.3L12 21l-2.3-6.7L3 12l6.7-2.3L12 3ZM20 2v4m-2-2h4"/>',
  'rotate-ccw': '<path d="M3 10a9 9 0 1 1 1 8M3 4v6h6"/>',
  'rotate-cw': '<path d="M21 10a9 9 0 1 0-1 8m1-14v6h-6"/>',
  settings:
    '<path d="m9.5 3-.6 2.1-1.8 1-2.2-.5-2.3 4 1.5 1.6v2l-1.5 1.6 2.3 4 2.2-.5 1.8 1 .6 2.1h5l.6-2.1 1.8-1 2.2.5 2.3-4-1.5-1.6v-2l1.5-1.6-2.3-4-2.2.5-1.8-1L14.5 3h-5Z"/><circle cx="12" cy="12" r="3"/>',
  play: '<path d="m8 5 11 7-11 7V5Z"/>',
  pause: '<path d="M8 5v14M16 5v14" stroke-width="3.5"/>',
  info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v6m0-10v.01"/>',
  code: '<path d="m7 6-6 6 6 6m10-12 6 6-6 6M14 3l-4 18"/>',
  expand:
    '<path d="M8 3H3v5m13-5h5v5M3 16v5h5m13-5v5h-5M3 3l6 6m12-6-6 6M3 21l6-6m12 6-6-6"/>',
  maximize: '<path d="M8 3H3v5m13-5h5v5M3 16v5h5m13-5v5h-5"/>',
  minimize: '<path d="M3 8h5V3m8 0v5h5M3 16h5v5m8 0v-5h5"/>',
  warn: '<path d="M12 3 2 21h20L12 3Z"/><path d="M12 10v5m0 3v.01"/>',
  lock: '<rect x="5" y="10" width="14" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3m-4 5v2"/>',
  'rotate-ccw-10': '<path d="M3 10a9 9 0 1 1 1 8M3 4v6h6"/>',
  'volume-x':
    '<path d="m11 4-6 5H2v6h3l6 5V4Zm5 5 6 6m0-6-6 6"/>',
  volume: '<path d="m11 4-6 5H2v6h3l6 5V4Zm4 4a6 6 0 0 1 0 8m3-11a10 10 0 0 1 0 14"/>',
  captions: '<rect x="2" y="4" width="20" height="16" rx="3"/><path d="M10 9H7v6h3m8-6h-3v6h3"/>',
  pip: '<rect x="2" y="3" width="20" height="18" rx="2"/><rect x="11" y="11" width="8" height="7" rx="1"/>',
  check: '<path d="m5 12 4 4L19 6"/>',
};

export function icon(name: string): string {
  return `<svg class="icon" viewBox="0 0 24 24" aria-hidden="true">${paths[name] ?? paths.info}</svg>`;
}

/** Replace every <i data-icon="…"> placeholder under root with its svg. */
export function hydrate(root: ParentNode = document): void {
  root.querySelectorAll("i[data-icon]").forEach((el) => {
    el.outerHTML = icon((el as HTMLElement).dataset.icon ?? "info");
  });
}

/** And the reverse swap used by dynamic control switching. */
export function setIcon(el: HTMLElement, name: string): void {
  el.innerHTML = icon(name);
}
